<div class="composed-search-container">
    @if (isMultiselect) {
        <app-status-filters-multi-select
            [statusesToDisplay]="statusesList"
            [id]="id + '-status-filters'"
            [selectedStatuses]="selectedStatuses"
            (statusesChanged)="updateStatus($event)">
        </app-status-filters-multi-select>
    } @else {
        <app-status-filters-single-select
            [statusesToDisplay]="statusesList"
            [id]="id + '-status-filters'"
            [selectedStatus]="selectedStatuses"
            [additionalFilters]="additionalFilters"
            (statusChanged)="updateStatus($event)"
            (additionalFilterValueChange)="additionalFilterValueChange.emit($event)">
        </app-status-filters-single-select>
    }

    <app-searchbar
        [value]="searchValue"
        [id]="id + '-search'"
        [searchPlaceholder]="searchPlaceholder | translate"
        (onSearch)="searchValueChange.emit($event)">
    </app-searchbar>
</div>
